import { i18n } from '@lingui/core';
import { BapSearchAd } from '@schibsted-nmp/search-frontend-components/react';
import { LegendaryBapSearchAd } from '@schibsted-nmp/search-frontend-components/react/legendary';
import React from 'react';
import type { BapPolePositionEntry } from '../../../server';
import { useAppConfig } from '../../AppConfig';
import type { Layout } from '../../data/SearchLayout';
import { FavoriteHeart } from '../FavoriteHeart';

const IMAGE_SIZES =
    '(min-width: 1300px) 306px, (min-width: 1010px) 316px, (min-width: 768px) 33vw, (min-width: 480px) 50vw, 100vw';

type RecommercePolePositionAdProps = {
    ad: BapPolePositionEntry;
    layout: Layout;
    onClick: () => void;
    promotedLabel?: string;
    renderTime?: number;
};

export function RecommercePolePositionAd(props: RecommercePolePositionAdProps) {
    const { ad, layout, onClick, promotedLabel, renderTime } = props;

    const { legendary } = useAppConfig();

    const adProps = {
        currentTime: renderTime,
        imageSize: IMAGE_SIZES,
        layout,
        onClick,
        url: ad.canonical_url,
    };

    const labelText =
        promotedLabel ??
        i18n.t({
            id: 'pole-position-ad.promoted-badge',
            message: 'Promoted ad',
        });

    const AdComponent = legendary ? LegendaryBapSearchAd : BapSearchAd;

    return (
        <AdComponent
            ad={ad}
            favorite={() => (
                <FavoriteHeart
                    itemId={ad.id}
                    variant={layout === 'grid' ? 'heart-on-image' : 'heart'}
                />
            )}
            label={({ className, classes }) => (
                <span
                    className={`${className} ${classes.badge} ${classes.info}`}
                >
                    {labelText}
                </span>
            )}
            {...adProps}
        />
    );
}
